export default __webpack_public_path__ + "static/media/omnix-logo.c569d3e2.svg";